import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/attritionAndCancelReasonsSaga";
import { useDateFormat } from "../../../../hooks/useDateFormat";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";

export const SingleDatePicker = () => {
  const dispatch = useDispatch();

  const dateFormat = useDateFormat();

  const date = useSelector((state) => state.attritionAndCancelReasons.selectedFilters.date);
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.attritionAndCancelReasons.currentUser
  );

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      startDate={date}
      updateDates={(data) => dispatch(actionCreators.updateFilter({ key: "date", data }))}
    />
  );
};
